import {
  Stepper,
  Step,
  Box,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Grid,
  useBreakpointValue,
  Text,
  Flex,
} from "@chakra-ui/react";

export default function StepperProgress({
  activeStep,
  steps,
  orientation,
  setActiveStep,
  disabledSteps,
}: any) {
  const isMobileView = useBreakpointValue({ base: true, md: false });
  return (
    <>
      {isMobileView ? (
        <Grid maxW="90vW" overflow="auto" className="customScrollBar">
          <Stepper
            colorScheme="teal"
            orientation={orientation}
            index={activeStep}
            // height='400px'
            justifyContent="center"
            mb={2}
          >
            {steps.map((step: any, index: any) => (
              <Step
                key={index}
                onClick={() => {
                  if (disabledSteps.includes(index)) {
                    setActiveStep(index);
                  }
                }}
                style={{
                  cursor: !disabledSteps.includes(index)
                    ? "not-allowed"
                    : "pointer",
                  opacity: !disabledSteps.includes(index) ? 0.5 : 1,
                }}
              >
                <StepIndicator>
                  <StepStatus
                    complete={<StepIcon />}
                    incomplete={<StepNumber />}
                    active={<StepNumber />}
                  />
                </StepIndicator>
                <StepSeparator />
              </Step>
            ))}
          </Stepper>
        </Grid>
      ) : (
        <Grid
          maxH={"94vh"}
          w={{md: "90vW", lg: "unset"}}
          rounded={"lg"}
          bg={"white"}
          boxShadow="rgb(0 0 0 / 12%) 0px 0px 11px"
          p={{base: 5, lg: 4}}
          // my={6}
        >
          <Stepper
            colorScheme="teal"
            orientation={orientation}
            index={activeStep}
          >
            {steps.map((step: any, index: any) => (
              <Step
                key={index}
                onClick={() => {
                  if (disabledSteps.includes(index)) {
                    setActiveStep(index);
                  }
                }}
                style={{
                  cursor: !disabledSteps.includes(index)
                    ? "not-allowed"
                    : "pointer",
                  opacity: !disabledSteps.includes(index) ? 0.5 : 1,
                  paddingBottom: orientation === 'vertical' && index !== steps.length - 1 ? '40px' : '0'
                }}
              >
                <Flex gap={3} alignItems="center">
                  <StepIndicator boxSize={10} fontSize="sm">
                    <StepStatus
                      complete={<StepIcon />}
                      incomplete={<StepNumber />}
                      active={<StepNumber />}
                    />
                  </StepIndicator>
                  <Box mt={0.5} display={{ base: "none", lg: "block" }}>
                    <StepTitle>
                      <Text fontSize="14px" fontWeight="500">{step.title}</Text>
                    </StepTitle>
                  </Box>
                </Flex>
              </Step>
            ))}
          </Stepper>
        </Grid>
      )}
    </>
  );
}
